import { Theme } from '@emotion/react';

import { colors } from '@/styles/color';
import { fontSize, fontWeight } from '@/styles/font';
import { heights } from '@/styles/heights';
import { motion } from '@/styles/motion';
import { breakpoints } from '@/styles/breakpoints';
import { borderRadius } from '@/styles/radius';
import * as scale from '@/styles/scale';

const theme: Theme = {
	fontSize,
	fontWeight,
	colors,
	scale,
	heights,
	motion,
	borderRadius,
	breakpoints,
};
export default theme;
